import CustomIcon from "../CustomIcon";

const Loader = () => {
    const src = window.logo;

    return (
        <div className="flex justify-center items-center" style={{ backgroundColor: "#f3f4f6", opacity: "0.85", height: "inherit", width: "inherit", zIndex: 1500, border: "0", padding: "0", }}>
            <CustomIcon
                id="loader-logo"
                src={src}
                alt="loader-logo"
            />
        </div>
    )
};

export default Loader;